export const normalizeBuildingQuery = params => {
  if (!params) return {}
  if (typeof params === 'number') return { buildingId: params }
  if (typeof params !== 'object') return {}

  const query = { ...params }
  const candidate = query.buildingId ?? query.id ?? query.building

  if (candidate && typeof candidate === 'object' && candidate.id !== undefined) {
    query.buildingId = candidate.id
    return query
  }

  if (candidate !== undefined) {
    query.buildingId = candidate
  }

  return query
}

export const downloadBlobResponse = (response, filename, extension) => {
  const blob = new Blob([response.data])
  const href = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = href
  anchor.download = `${filename}.${extension}`
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  window.URL.revokeObjectURL(href)
}
